import axios from 'axios'

// Determine base URL for API requests
const getBaseUrl = () => {
  // If an environment variable is set, use that
  if (process.env.VUE_APP_API_URL) {
    return process.env.VUE_APP_API_URL;
  }
  
  // In development, use the proxy defined in vue.config.js
  // This will automatically redirect to backend without specifying port
  return '/api';
};

// Create axios instance with default config
const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Create a public API instance without authentication
const publicApi = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Intercept requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Intercept responses
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Handle 401 Unauthorized responses
    if (error.response && error.response.status === 401) {
      // Clear local storage
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      
      // Redirect to login
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export { publicApi }
export default api